export default __webpack_public_path__ + "static/33across-3a61662bd30cd202f1338d8984c57dc7.svg";